import { RequestOrderItem } from "store/back-counter/back-counter.entities";
import { DeliveryOption, RequestType } from "./back-counter-request-tab";

export const QUOTE: string = "01";
export const NEED: string = "02";
export const ORDER: string = "03";
export const GENERAL_REQUEST: string = "90";
export const PICK: string = "05";

export const BackCounterRequestType: RequestType = {
  GENERAL_REQUEST,
  NEED,
  ORDER,
  QUOTE,
  PICK
};

export const BLANK = "";
export const SELF_PICK = "L";
export const BASKET_RETURNS_SHOWROOM = "A";
export const DELIVERY_OPTIONS = [BLANK, SELF_PICK, BASKET_RETURNS_SHOWROOM];
export const SELF_PICK_TEXT = "Self Pick";
export const BASKET_RETURNS_SHOWROOM_TEXT = "Basket/Returns/Show room";
export const QUOTE_TEXT = "Quote";
export const NEED_TEXT = "Need";
export const ORDER_TEXT = "Order";
export const GENERAL_REQUEST_TEXT = "General Request";

export const BackCounterDeliveryOption: DeliveryOption = {
  BASKET_RETURNS_SHOWROOM,
  BLANK,
  SELF_PICK,
};

export const PERFECTION_ONLY = "95";
export const NO_ORDER = "99";

export const getCreatePurchaseOrderFlags = (
  requestOrderItems: RequestOrderItem[]
): [boolean, boolean, boolean, boolean] => {
  const outOfStockItems = requestOrderItems.filter(
    (s) => s?.quantityAvailable < s?.reqQuantity || s?.ohAvailableQty === 0
  );
  const hasOutOfStockItems = outOfStockItems?.length > 0;
  const outOfStockItemWithHotFlag99Or95 = outOfStockItems.some(f => f.hotflag === NO_ORDER || f.hotflag === PERFECTION_ONLY);
  const hasPartsBuyout = outOfStockItems.some(f => !!f.buyout);
  const hasStockTransferOrder = outOfStockItems.some(f => !!f.sto);
  return [hasOutOfStockItems, outOfStockItemWithHotFlag99Or95, hasPartsBuyout, hasStockTransferOrder];
};
